const $ = window.jQuery;
import { observeElementInView } from "../vendor/inview-observer";
// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";
import '@justinribeiro/lite-youtube';


$(function () {
	"use strict";

	const carousels = document.querySelectorAll(".feature-carousel-members");

	carousels.forEach((carousel) => {
		const callback = () => {
			if (carousel.dataset.initialized === "true") return;

			const swiperEl = carousel.querySelector(".swiper");
			const paginationEl = carousel.querySelector(".swiper-pagination");
			if (!swiperEl || !paginationEl) return;

			// With very few slides (e.g. 2), Swiper loop mode can duplicate slides and create
			// extra pagination bullets (especially across resizes/breakpoints).
			const realSlidesCount = swiperEl.querySelectorAll(".feature-carousel-members .swiper-wrapper > .swiper-slide").length;
			const shouldLoop = realSlidesCount > 2;

			const showperSlide = realSlidesCount > 4 ? 4 : 3;


			if (carousel.swiperInstance) {
				carousel.swiperInstance.destroy(true, true);
			}

			// Ensure we don't accumulate bullets if something re-inits.
			paginationEl.innerHTML = "";

			carousel.swiperInstance = new Swiper(swiperEl, {
				mousewheel: false,
				initialSlide: 0,
				speed: 700,
				//effect: "fade",
				//fadeEffect: { crossFade: true },//must be used when effect fade is enabled
				grabCursor: false,
				centeredSlides: false,
				slidesPerView: 1,
				spaceBetween: 40,
				loop: shouldLoop,
				watchOverflow: true,
				autoHeight: false,
				navigation: {
					nextEl: '.feature-carousel-members .swiper-button-next',
					prevEl: '.feature-carousel-members .swiper-button-prev',
				},
				lazy: {
					loadPrevNext: true,
				},
				pagination: {
					el: paginationEl,
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
					1336: {
						slidesPerView: 3,
					},
					1441: {
						slidesPerView: showperSlide,
					},
				},
			});

			carousel.dataset.initialized = "true";
		};

		observeElementInView(carousel, callback);
	});

	
	
});